module.exports = __webpack_public_path__ + "static/img/v3.0b9905a7.png";